import React, { useContext, useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { getShopProducts, textSearch } from '../../helpers/apiClient'
import AppContext from '../../helpers/AppContext'
import { useTranslate } from '../../helpers/useTranslate'
import ProductList from '../ProductList'
import Section, { SectionControl } from '../Section/Section'
import TextLine from '../TextLine'

export interface Props extends RouteComponentProps {
    className?: string
}

const VintageProductsPreview: React.FC<Props> = (props) => {
    const { className } = props
    const { translate } = useTranslate()
    const ctx = useContext(AppContext)
    const [products, setProducts] = useState<Product[]>([])
    const searchVendorQueries: string[] = [
       'openforvintage',
       'goldsmithvintage'
    ]
    const query = searchVendorQueries.toString()

    const seeAll = (props: Props) => {
        ReactGA.event({
            category: 'User',
            action: `Clicked 'see all vinatge products'`
        })
    
        props.history.push(`/shop/vintage?vendors=${query}`)
    }

    useEffect(() => {
        textSearch(query)
            .then((res) => {
                setProducts(res.result)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    const trackClick = () => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked on vintage products'
        })
    }

    const productList = (
        <ProductList
            products={products}
            maxLength={4}
            onProductClick={trackClick}
            disableTracking={true}
        />
    )
    const sectionControls: SectionControl[] = []
    const control = {
        content: (
            <TextLine
                className="subtitle"
                text={translate('SEE_ALL')}
                type="small"
                underline={true}
                inline={true}
            />
        ),
        onClick: () => {
            seeAll(props)
        }
    }

    if (ctx.isDesktop) {
        sectionControls.push(control)
    }

    const section = products.length ? (
        <Section
            title={translate('VINTAGE_SHOPS')}
            body={productList}
            controls={sectionControls}
            bottomCTA={ctx.isDesktop ? undefined : control}
        />
    ) : null

    return <div className={className}>{section}</div>
}

const StyledVintageProductsPreview = styled(VintageProductsPreview)((props) => {
    return {
        minHeight: '350px'
    }
})

export default withRouter(StyledVintageProductsPreview)
